import React from 'react';
import { createPortal } from 'react-dom';
import { ClockIcon, ChevronDownIcon } from '../icons';
import { formatDurationMinutes } from '../../../../../utils/taskDuration';

/** Presets in minutes: 1h, 2h, 4h, 8h, 1d, 2d, 7d, 30d */
const PRESETS_MINUTES = [60, 120, 240, 480, 1440, 2880, 10080, 43200];

/**
 * Bulk estimated duration dropdown — sets `estimatedDurationMinutes` on selected tasks
 */
const EstimatedDurationDropdown = ({
  isActive,
  onToggle,
  onEstimatedDurationMinutesChange,
  menuStyle,
  buttonRef,
}) => {
  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={(e) => onToggle('estimate', e.currentTarget)}
        title="Set estimated time"
      >
        <ClockIcon />
        <span>Est.</span>
        <ChevronDownIcon />
      </button>
      {isActive && createPortal(
        <div className="bulk-actions-toolbar__menu" style={menuStyle}>
          <button className="bulk-actions-toolbar__menu-item" onClick={() => onEstimatedDurationMinutesChange(null)}>
            Clear estimate
          </button>
          {PRESETS_MINUTES.map((minutes) => (
            <button
              key={minutes}
              className="bulk-actions-toolbar__menu-item"
              onClick={() => onEstimatedDurationMinutesChange(minutes)}
            >
              {formatDurationMinutes(minutes)}
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default EstimatedDurationDropdown;
